export default {
  AUTH_TOKEN: "auth-token",
  REFRESH_TOKEN: "refresh-token",
  DEFAULT_LANG: "default-lang",
  USER_TYPE: "user-type",
  USER_ID: "user-id",
};
